document.addEventListener('DOMContentLoaded', function () {

    // Add footer content inside contact info
    const contactInfo = document.querySelector('.contact-template__box ul.contact-info');
    const footerContent = document.querySelector('.site-footer__rte.site-footer__rte--text');

    if (contactInfo && footerContent) {
        const li = document.createElement('li');
        li.className = 'pz-socials';

        li.innerHTML = footerContent.innerHTML;

        contactInfo.appendChild(li);
    }


    // Add active class to footer menu items
    const currentPath = window.location.pathname.replace(/\/$/, '') || '/';

    document.querySelectorAll('.site-footer__linklist-item a').forEach(function (link) {
        const linkURL = new URL(link.href, window.location.origin);
        const linkPath = linkURL.pathname.replace(/\/$/, '') || '/';

        if (linkPath === currentPath) {
            link.closest('.site-footer__linklist-item').classList.add('pz-active-item');
        }
    });

    // Remove title attributes
    document.querySelectorAll('.site-footer__rte.site-footer__rte--text ul li a').forEach(function (link) {
        link.removeAttribute('title');
    });

    // Make phone contact item clickable
    document.querySelectorAll('.contact-info__phone').forEach(function (phoneItem) {
        phoneItem.style.cursor = 'pointer';

        phoneItem.addEventListener('click', function () {
            window.location.href = 'tel:7185061610';
        });
    });

    // Scroll reveal animations
const animatedSections = [
    '.ai-hero-banner__container-arhhvz1j4u0zpd1pqcaigenblock00d419fme4njd',
    '.ai-image-grid-section-aofc3yksrofftc1jbtaigenblock3252a5bnwkbyz',
    '.ai-hero-banner__container-aq1vpywxdbxdwcvexvaigenblock00d419fdgbjmd',
    '.ai-single-image-container-az2tzayt0t1ntakdstaigenblock3d88581bpwue8',
    '.ai-hero-container-azwztt0y2ajdxsnjlwaigenblock6b0f664cjf4bh',
    '.section-sections--23083722309880__newsletter-padding .newsletter-section.alt-background-3 .page-width',
    '.ai-image-content-container-anvqxszhxug1yk2hcraigenblock2a2fef0gmiw8t',
    '.ai-single-image-container-aqlarcnr4v21jk3lpsaigenblock3d88581kbqfgb',
    '.ai-logo-grid-ar3rstmz4z244rmi1raigenblock4cd8b1cn4rgzj'
];

const observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            entry.target.classList.add('pz-visible');
            observer.unobserve(entry.target);
        }
    });
}, {
    threshold: 0.15
});

animatedSections.forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (section) {
        section.classList.add('pz-scroll-reveal');
        observer.observe(section);
    });
});

});
